import React from "react";
import "../styles/home.css";
import uoLogo from "../img/uo.png";
import instagramLogo from "../img/instagram.svg";
import facebookLogo from "../img/facebook.svg";
import discordLogo from "../img/discord.svg";

function Home() {
  return (
    <div className="home__container">
      <div className="uo__logo">
        <img src={uoLogo} alt="uo_logo" />
      </div>
      <div className="social">
        <a
          target="_blank"
          href={`${process.env.REACT_APP_URL_DISCORD}`}
          className="social__link"
        >
          <img src={discordLogo} alt="discord_logo" />
        </a>
        <a
          target="_blank"
          href={`${process.env.REACT_APP_URL_INSTAGRAM}`}
          className="social__link"
        >
          <img src={instagramLogo} alt="instagram_logo" />
        </a>
        <a
          target="_blank"
          href={`${process.env.REACT_APP_URL_FACEBOOK}`}
          className="social__link"
        >
          <img src={facebookLogo} alt="facebook_logo" />
        </a>
      </div>
    </div>
  );
}

export default Home;
